import {
  AccordionDetails,
  Box,
  Divider,
  SxProps,
  Typography,
} from '@mui/material';

import { MAIN_TABLE_TITLE_STYLES } from '../../constants';
import {
  StyledAccordion,
  StyledAccordionSummary,
  StyledHeaderBox,
  StyledIcon,
  StyledStack,
  StyledTypography,
} from './SidePanel.styled';
import { ISidePanelItem, SidePanelItem } from './SidePanelItem';

export type ISidePanelItemListProps = {
  title: string;
  items: ISidePanelItem[];
};

type ISidePanelProps = {
  title: string;
  items: ISidePanelItemListProps[];
  containerSx?: SxProps;
};

const SidePanelItemList = (props: {
  items: ISidePanelItemListProps['items'];
}) => {
  return (
    <>
      {props.items.map((item, index) => (
        <Box key={item.position}>
          <SidePanelItem item={item} />
          {index < props.items.length - 1 && <Divider />}
        </Box>
      ))}
    </>
  );
};

export const SidePanel = (props: ISidePanelProps) => {
  return (
    <StyledStack sx={props.containerSx}>
      <StyledHeaderBox>
        <Typography sx={MAIN_TABLE_TITLE_STYLES}>{props.title}</Typography>
      </StyledHeaderBox>

      {props.items.map((item) => (
        <StyledAccordion key={item.title}>
          <StyledAccordionSummary expandIcon={<StyledIcon />}>
            <StyledTypography>{item.title}</StyledTypography>
          </StyledAccordionSummary>
          <AccordionDetails>
            <SidePanelItemList items={item.items} />
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </StyledStack>
  );
};
